import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import he from "./locales/he.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGUAGES = ["he", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "he";

const LANGUAGE_STORAGE_KEY = "multi-chat:language";

export function getStoredLanguage(): SupportedLanguage | null {
  const raw = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (raw === "he" || raw === "en") return raw;
  return null;
}

export function storeLanguage(lang: SupportedLanguage): void {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
}

function detectInitialLanguage(): SupportedLanguage {
  const stored = getStoredLanguage();
  if (stored) return stored;
  return DEFAULT_LANGUAGE;
}

function applyDocumentLanguage(lang: SupportedLanguage): void {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "he" ? "rtl" : "ltr";
}

const initialLanguage = detectInitialLanguage();

void i18n.use(initReactI18next).init({
  resources: {
    he: { translation: he },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

applyDocumentLanguage(initialLanguage);

i18n.on("languageChanged", (lang: string) => {
  if (lang === "he" || lang === "en") {
    applyDocumentLanguage(lang);
    storeLanguage(lang);
  }
});

export default i18n;
